function toArray() {
	return function (map) {
		return Array.from(map.values());
	};
}

export {
	toArray
};